import Route from '@ember/routing/route';

import type { LibraryClientsEditModel } from '../client';

export default class LibraryClientsClientEditRoute extends Route {
  model(): LibraryClientsEditModel {
    return this.modelFor('library.clients.client') as LibraryClientsEditModel;
  }
}
